import { applyMuted } from '~/assets/sounds';
import { IObservable, Subject } from '~/rage/utils';
import type { ISoundsService } from './soundsServiceTypes';

export class SoundsServiceStub implements ISoundsService {
	private readonly muted = new Subject<boolean>(false);

	constructor() {
		this.muted.subscribe((value) => {
			applyMuted(value);
		});
	}

	public getMutedObservable(): IObservable<boolean> {
		return this.muted;
	}

	public toggleMuted(): void {
		this.muted.next(!this.muted.getValue());
	}
}
